import React from "react";
import { Button, Typography, Box } from "@mui/material";
import { motion } from "framer-motion";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SEOHead from "../components/_layout/_default/header/SEOHead";
import siteData from "../_data";
import theme from "../_theme";

const ErrorPage = ({
  error = { message: "An unexpected error occurred. Please try again later." },
  resetErrorBoundary = () => window.location.reload(),
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      textAlign="center"
      bgcolor="error.light"
      color="grey.400"
      p={3}
    >
      <SEOHead
        title={`Error | ${siteData.brand.name}`}
        description="An error occurred while loading the page. Please try again."
        themeColor={theme.palette.error.light}
      />

      {/* Error icon with animation */}
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 100, damping: 10 }}
        whileHover={{ scale: 1.1 }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 100, color: "white.main", mb: 2 }} />
      </motion.div>

      {/* Text animations */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <Typography variant="h4" color="grey.300" gutterBottom>
          Something went wrong
        </Typography>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6 }}
      >
        <Typography variant="body1" color="grey.300" lineHeight={"1.5rem"}>
          {error?.message ||
            "An unexpected error occurred. Please try again later."}
        </Typography>
      </motion.div>

      {/* Retry button with pulse animation */}
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <Button
          variant="contained"
          sx={{ mt: 2, color: "error.light" }}
          onClick={resetErrorBoundary}
          style={{ backgroundColor: "white" }}
        >
          Try Again
        </Button>
      </motion.div>
    </Box>
  );
};

export default ErrorPage;
